import { Injectable, Injector } from "@angular/core";
import { SdkBase } from "../utilities/sdk-base/sdk.base";
import { Observable, map, of } from "rxjs";
import { UploadBatchNativeReport } from "@models/ui/upload-batch-native-report.model";
import { UploadBatchNativeReportResource } from "@models/resource/upload-batch-native-report.resource";
import { UploadBatchNativeReportResourceToUploadBatchNativeReportMapper } from "@models/mappers/upload-batch-native-report-resource-to-upload-batch-native-report.mapper";

const mapper = new UploadBatchNativeReportResourceToUploadBatchNativeReportMapper();

@Injectable({
    providedIn: 'root'
})
export class UploadBatchNativeReportSdk extends SdkBase {
    constructor(injector: Injector) {
		super(injector);
	}

    public get(params: NativeUploadBatchGetParams): Observable<UploadBatchNativeReport> { 
        if (!params?.id) return of(null);
        return this.makeHttpRequest<UploadBatchNativeReportResource>('get', `api2/native-upload-batch-reports/${params.id}`).pipe(
            map(response => {
                const item = mapper.map(response);
                return item;
            })
        );
	}
}

interface NativeUploadBatchGetParams {
    id?: string;
}
